import { render, staticRenderFns } from "./FalePresidente.vue?vue&type=template&id=b45d9ae8&scoped=true"
import script from "./FalePresidente.vue?vue&type=script&lang=js"
export * from "./FalePresidente.vue?vue&type=script&lang=js"
import style0 from "./FalePresidente.vue?vue&type=style&index=0&id=b45d9ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45d9ae8",
  null
  
)

export default component.exports